import { RootModel } from 'models';
import { createModel } from '@rematch/core';
import { baseReducers, BaseState } from './baseReducers';
import { SkuSlaDTO } from '../domains/slaDomain';

interface SLAState extends BaseState {
  slaList: SkuSlaDTO[];
}

export const sla = createModel<RootModel>()({
  state: {
    slaList: [],
  } as SLAState,
  reducers: {
    ...baseReducers<SLAState>(),
    updateSlaSupplier: (state: SLAState, payload: SkuSlaDTO) => {
      const index = state.slaList.findIndex((item) => item.id === payload.id);
      if (index > -1) {
        state.slaList[index] = payload;
      }
      return state;
    },
    deleteSla: (state: SLAState, payload: number) => {
      state.slaList = state.slaList.filter((item) => item.id !== payload);
      return state;
    },
  },
  effects: (dispatch) => {
    // const { SLA } = dispatch;
    return {};
  },
});
